import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Also scroll the root element since it has overflow-y: auto
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.scrollTop = 0;
    }
    // Also scroll the map menu content container if it exists
    const mapMenuContainer = document.querySelector('.map-menu-overlay div[style*="overflow: auto"]');
    if (mapMenuContainer) {
      mapMenuContainer.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}
